import { CountUp } from 'use-count-up'

export const NumberCountUp = ({ value }: { value: number }) => {
  return <CountUp duration={1} end={value} isCounting key={value} />
}
